/**
 * PC 트레이 앱(loginHS) 안에서만 보이는 뒤로·앞으로 버튼(2026-10-06) — 앱 창에는 브라우저 주소창·뒤로 버튼이 없다.
 * 앱 안인지는 트레이가 처음 연 주소의 agent=1 을 기억한 값(loginhs:in-agent)으로 본다.
 */
import React from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";

export function inAgentApp() {
  try { return localStorage.getItem("loginhs:in-agent") === "1"; } catch { return false; }
}

const btn = {
  display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28,
  border: "1px solid var(--audit-border, #e3e6ea)", borderRadius: 6, background: "transparent", cursor: "pointer", color: "#4b5563",
};

export default function AgentNav() {
  if (!inAgentApp()) return null;
  return (
    <span data-testid="agent-nav" style={{ display: "inline-flex", gap: 4, flexShrink: 0 }}>
      <button type="button" style={btn} title="이전 화면 (Alt+←)" aria-label="이전 화면" onClick={() => window.history.back()}><ArrowLeft size={15} /></button>
      <button type="button" style={btn} title="다음 화면 (Alt+→)" aria-label="다음 화면" onClick={() => window.history.forward()}><ArrowRight size={15} /></button>
    </span>
  );
}
